<template>
  <CardPrimary :style="cardStyle">
    <div :style="fixedColumnsContainerStyle">
      <div :style="emptyColumnContainerStyle">
        <TableEmptyColumnPrimary :rowsLength="tenantUsers.length" />
      </div>
      <div :style="userColumnContainerStyle">
        <TableUserColumnPrimary header="Name"
                                :rows="tenantUsers"
                                :truncate="true" />
      </div>
    </div>
    <div :style="scrollableColumnsContainerStyle">
      <div :style="titleColumnContainerStyle">
        <TableColumnPrimary header="Title"
                            :rows="titles"
                            :truncate="true" />
      </div>
      <div :style="joinedDateColumnContainerStyle">
        <TableColumnPrimary header="Joined"
                            :rows="joinedDates"
                            :truncate="true" />
      </div>
      <div :style="emptyColumnContainerStyle">
        <TableEmptyColumnPrimary :rowsLength="tenantUsers.length" />
      </div>
    </div>
  </CardPrimary>
</template>

<script>
  import CardPrimary from '@modules/card/card-primary'
  import TableColumnPrimary from '@modules/table/table-column-primary'
  import TableEmptyColumnPrimary from '@modules/table/table-empty-column-primary'
  import TableUserColumnPrimary from '@modules/table/table-user-column-primary'
  import { Layout } from '@js/styles'
  import { getLocaleDateString } from '@js/date-utils'
  import { mapState } from 'vuex'

  export default {
    name: 'UsersTable',
    components: {
      CardPrimary,
      TableColumnPrimary,
      TableEmptyColumnPrimary,
      TableUserColumnPrimary,
    },
    props: {
      tenantUsers: { type: Array, required: false, default: () => [] },
    },
    data: function () {
      return {
        cardStyle: {
          alignItems: 'flex-start',
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: '60px',
          width: '100%',
        },
        emptyColumnContainerStyle: {
          width: Layout.space.sm,
        },
        fixedColumnsContainerStyle: {
          display: 'flex',
          flex: 1,
        },
        joinedDateColumnContainerStyle: {
          flex: 1,
          minWidth: '120px',
        },
        scrollableColumnsContainerStyle: {
          display: 'flex',
          flex: 1,
          justifyContent: 'space-between',
          overflowX: 'scroll',
        },
        titleColumnContainerStyle: {
          flex: 2,
          minWidth: '200px',
        },
        userColumnContainerStyle: {
          flex: 1,
        },
      };
    },
    computed: {
      ...mapState({
        timezone: state => state.user.timezone,
      }),
      users: function () {
        return this.tenantUsers.map(elem => elem.user);
      },
      titles: function () {
        return this.tenantUsers.map(elem => elem.title.length > 0 ? elem.title : 'N/A');
      },
      joinedDates: function () {
        return this.tenantUsers.map(elem => getLocaleDateString(elem.joinedAt, this.timezone));
      },
    },
  };
</script>

